import React, { ReactNode, Fragment, useLayoutEffect, useContext } from 'react'
import { useState, useEffect } from 'react'
import { AppGridSearchContext } from './AppGridSearchContext'
import { AppGridSearchProps, AppSearchData, getSearchObject } from './AppGridSearchData'
import { AppProjectTreeSearch, MoreLink, AppTableCommonSearchItem } from './AppGridCommonSearchItem'
import { AppGridAdvancedSearchItem as AppGridAdvancedSearchItemProps } from '../../api/index'
import { AppGridAdvancedSearchItem, AllCheck, Condition } from './AppGridAdvancedSearchItem'
import { Button } from 'antd'
import { AppGridLayoutContext } from 'components/AppGridLayout/AppGridLayout'

const getDefaultHasMoreSearch = (props: AppGridSearchProps) => {
	return props.advancedSearch &&
		props.advancedSearch.appGridAdvancedSearchItemList &&
		props.advancedSearch.appGridAdvancedSearchItemList.length > 0
		? true
		: false
}

export const AppGridSearch = (props: AppGridSearchProps) => {
	const [appSearchDataList, setAppSearchDataList] = useState(props.defaultData || [])
	const [hasMoreSearch, setHasMoreSearch] = useState(getDefaultHasMoreSearch(props))
	const [showMore, setShowMore] = useState(props.defaultShowMore || false)

	const onSearch = () => {
		props.onSearch && props.onSearch(appSearchDataList, getSearchObject(appSearchDataList))
	}

	const onChange = (appSearchData: AppSearchData) => {
		let isExit = false
		let appSearchDataListNew = appSearchDataList.map((data: AppSearchData) => {
			if (data.keyName === appSearchData.keyName) {
				isExit = true
				return appSearchData
			} else return data
		})
		if (!isExit) appSearchDataListNew.push(appSearchData)
		setAppSearchDataList(appSearchDataListNew)
	}

	const handleClickMore = () => {
		setShowMore(!showMore)
	}

	const clearSearchDataByField = (keyName: string) => {
		let appSearchDataListNew = appSearchDataList.filter(o => o.keyName !== keyName)
		setAppSearchDataList(appSearchDataListNew)
	}

	const clearSearchData = () => {
		let appSearchDataListNew = [] as AppSearchData[]
		setAppSearchDataList(appSearchDataListNew)
	}

	const renderProjectFilter = () => {
		if (props.projectFilter) {
			return (
				<AppProjectTreeSearch
					scene={props.projectFilterType}
					field={props.projectFilterField}
					label={props.projectFilterLabel}
					keyName={props.projectFilterKeyName}
				/>
			)
		}
		return <React.Fragment />
	}

	const renderMore = () => {
		if (!hasMoreSearch) return <React.Fragment />
		return <MoreLink />
	}

	const renderCommon = () => {
		let commonSearchList = props.commonSearchList || []
		if (commonSearchList.length === 0) return <React.Fragment />
		return <AppTableCommonSearchItem commonSearchList={commonSearchList} />
	}

	const renderCondition = () => {
		// 1
		if (showMore) return <React.Fragment />
		return <Condition />
	}

	const renderAdvanced = () => {
		if (!showMore || !hasMoreSearch) return <React.Fragment />
		let advancedSearch = props.advancedSearch || {}
		let appGridAdvancedSearchItemList = advancedSearch.appGridAdvancedSearchItemList

		return (
			<div className="app-grid-advanced-search-border">
				<table className="app-grid-advanced-search-controls">
					<tbody>
						{appGridAdvancedSearchItemList.map(
							(appGridAdvancedSearchItem: AppGridAdvancedSearchItemProps) => {
								return (
									<tr
										className="app-grid-advanced-search-item"
										key={appGridAdvancedSearchItem.keyName}
									>
										<th
											className="app-grid-advanced-search-label"
											style={{ width: advancedSearch.labelWidth || 110 }}
										>
											<span>{appGridAdvancedSearchItem.label}：</span>
										</th>
										<td className="app-grid-advanced-search-target">
											<div className="app-grid-advanced-search-item-inner">
												<AppGridAdvancedSearchItem {...appGridAdvancedSearchItem} />
											</div>
										</td>
									</tr>
								)
							}
						)}
					</tbody>
				</table>
			</div>
		)
	}

	const renderSearchBar = () => {
		// 1
		if (!showMore || !hasMoreSearch) return <React.Fragment />
		return (
			<div className="app-grid-advanced-search-toolbar">
				<Button className="app-grid-advanced-search-toolbar-search" type="primary" onClick={onSearch}>
					搜索
				</Button>
				<Button className="app-grid-advanced-search-toolbar-clear" onClick={clearSearchData}>
					清空
				</Button>
			</div>
		)
	}

	let refAppGridSearch = React.useRef<HTMLDivElement>()
	const { calViewHeight } = useContext(AppGridLayoutContext)

	useEffect(() => {
		// DOM 更新完成后打印出 div 的高度
		// console.log('refAppGridSearch', refAppGridSearch)
		calAppGridSearchHeight()
	})

	const calAppGridSearchHeight = () => {
		return '';
		// calViewHeight(refAppGridSearch && refAppGridSearch.current && refAppGridSearch.current.clientHeight)
	}

	return (
		<AppGridSearchContext.Provider
			value={{
				appSearchDataList,
				showMore,
				onSearch,
				handleClickMore,
				onChange,
				clearSearchDataByField,
				calAppGridSearchHeight,
			}}
		>
			<div className="app-grid-search" ref={refAppGridSearch}>
				<div className="app-grid-common-search">
					{renderProjectFilter()}
					{renderCommon()}
					{renderMore()}
				</div>
				<div className="app-grid-advanced-search" style={showMore ? { paddingBottom: '14px' } : {}}>
					{renderCondition()}
					{renderAdvanced()}
					{renderSearchBar()}
				</div>
			</div>
		</AppGridSearchContext.Provider>
	)
}



// WEBPACK FOOTER //
// ./src/components/AppTableSearch/AppGridSearch.tsx